var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asset-editor',{attrs:{"is-saving":_vm.isSaving},on:{"save":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }